export default __webpack_public_path__ + "static/media/Calender.87526494.svg";